/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Manual_Qc_Event_Count_BadgeInputs */

const en_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} event(s)`)
};

const fr_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} evenement(s)`)
};

const de_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Ereignis(se)`)
};

const it_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} evento/i`)
};

const ru_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие(я) ${i?.count}`)
};

const es_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} evento(s)`)
};

const zh_cn2_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 事件`)
};

const ja_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件のイベント`)
};

const hi_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} घटना(एँ)`)
};

const pt_pt2_manual_qc_event_count_badge = /** @type {(inputs: Manual_Qc_Event_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`evento(s) ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{count} event(s)" |
*
* @param {Manual_Qc_Event_Count_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_event_count_badge = /** @type {((inputs: Manual_Qc_Event_Count_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Event_Count_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_event_count_badge(inputs)
	if (locale === "de") return de_manual_qc_event_count_badge(inputs)
	if (locale === "it") return it_manual_qc_event_count_badge(inputs)
	if (locale === "ru") return ru_manual_qc_event_count_badge(inputs)
	if (locale === "es") return es_manual_qc_event_count_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_event_count_badge(inputs)
	if (locale === "ja") return ja_manual_qc_event_count_badge(inputs)
	if (locale === "hi") return hi_manual_qc_event_count_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_event_count_badge(inputs)
	return en_manual_qc_event_count_badge(inputs)
});